<template>
    <div class="addClientes">
        <div class="dvTitle bg-light">
            <h5 class="subtitle" >
                Agregar Cliente
            </h5>
        </div>

        <div class="dvContenedor">

            <b-form @submit="save" class="mb-4">
                <div class="form">
                    <div class="col-md-12">

                        <div class="form-group">
                            <label>
                                RFC <b>*</b>
                                <Input required v-model="data.tax_id" :class="data.errorDescripcion ? 'has-error' : ''"
                                       @search="validarInput('tax_id','errorDescripcion')"/>
                            </label>
                        </div>

                        <div class="form-group">
                            <label>
                                Razón Social <b>*</b>
                                <Input required v-model="data.legal_name" :class="data.errorName ? 'has-error' : ''"
                                       @search="validarInput('legal_name','errorName')"/>
                            </label>
                        </div>

                        <div class="form-group">
                            <label>
                                Email <b>*</b>
                                <Input required v-model="data.email" type="email"
                                       :class="data.errorEmail ? 'has-error' : ''"
                                       @search="validarInput('email','errorEmail')"/>
                            </label>
                        </div>

                    </div>
                </div>

                <div class="col-md-12 text-left d-flex justify-content-between mt-4">
                    <div class="btn btn-secondary" @click="cancelar">
                        <i class="fas fa-times-circle mr-1"></i>
                        Cancelar
                    </div>
                    <div class="btn btn-danger" @click="guardar" >
                        <i class="far fa-save mr-1"></i>
                        Guardar
                    </div>
                </div>

                <input type="submit" id="frProducto" class="d-none" v-show="dummy">

            </b-form>
        </div>

    </div>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex';
    import swal from 'sweetalert';
    import Input from "../../components/comun/Input";
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "AddClientes",
        components: {Input},

        computed: {
            ...mapState([
                'refresh'
            ]),
        },

        data() {
            return {
                data: {},
                dummy: true
            }
        },

        methods: {

            ...mapMutations([
                'SET_TOTALES'
            ]),

            ...mapActions([
                'getTotales',
                'postSaveCliente',
            ]),

            validarInput: function (input, error) {
                if ( !this.data[input] ) {
                    this.data[error] = true;
                } else {
                    this.data[error] = false;
                }
            },

            cancelar: function () {
                this.$router.push('/Clientes');
            },

            guardar: function () {
                if (this.validar()) {
                    document.getElementById('frProducto').click()
                }
            },

            validar: function () {
                let isOK = true;

                if ( !this.data.tax_id ) {
                    this.data.errorDescripcion = true;
                    isOK = false;
                } else {
                    this.data.errorDescripcion = false;
                }

                if ( !this.data.legal_name ) {
                    this.data.errorName = true;
                    isOK = false;
                } else {
                    this.data.errorName = false;
                }

                if ( !this.data.email ) {
                    this.data.errorEmail = true;
                    isOK = false;
                } else {
                    this.data.errorEmail = false;
                }

                this.dummy = !this.dummy;
                return isOK;
            },

            save: function (event) {
                event.preventDefault();
                this.postSaveCliente(this.data).then( data => {
                    swal('Operación exitosa', "Los datos fueron guardados exitosamente",'success' );
                    this.getTotales().then( data => {
                        this.SET_TOTALES(data);
                        this.$router.push('/Clientes');
                    });
                }).catch( err => {
                    swal('Error', "No se pudo guardar la información, intentelo más tarde.",'error' );
                });
            }
        }

    }
</script>

<style scoped lang="scss">

    @import "../../style/base";

    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    input[type=number] {
        -moz-appearance: textfield;
        appearance: textfield;
        margin: 0;
    }

    .addClientes {

        border: 1px solid #e6ebf4;
        border-radius: .25rem;
        background-color: #fff;
        margin: 20px;

        animation-name: fade;
        animation-duration: 1.5s;
        animation-timing-function: ease-in-out;

        & .dvTitle {
            @include flexRow;
            justify-content: space-between;
            align-items: center;
            padding: .75rem 1.25rem;
        }

        & .dvContenedor {
            transition: opacity .25s ease-out;
            width: 100%;
            margin: 0 auto;
            padding: 1.25rem 1.25rem 1px;
            overflow-x: visible;

            & div.form {
                width: 100%;
                text-align: left;

                & label {
                    font-size: 1.1rem;
                    font-weight: 600;
                    width: 100%;

                    &.form-check {
                        @include flexRow;
                        align-items: center;
                        padding: 0;

                        & span {
                            order: 2;
                        }

                        & input {
                            width: 25px;
                            order: 1;

                            &.last {
                                order: 3;
                            }
                        }
                    }
                }
            }

        }
    }

</style>